import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import ErrorBoundary from '@shared/v2/components/ErrorBoundary';

import { TILE_TYPE } from '@/constants';
import { Tile } from '@/propTypes/Campaign';
import PropertyOption from './components/PropertyOption';

const StyledBox = styled(Box)`
  scroll-margin-top: 110px; //Size of sticky origin bar
`;

const Tiles = ({
  tiles,
  priceForAdult = false,
  hidePerPersonPrice = false,
  procuredOfferSash,
  standardPropertySash,
}) => {
  return (
    <>
      {tiles?.map((tile, index) => {
        if (!tile) {
          return null;
        }

        let tileFlightPromotionCode;
        if (tile.type === TILE_TYPE.STANDARD_PROPERTY) {
          tileFlightPromotionCode =
            tile?.sashing?.flightPromoCode ??
            standardPropertySash(tile.propertyId);
        } else if (
          tile.type === TILE_TYPE.PROCURED_OFFER &&
          tile.procuredOffer
        ) {
          tileFlightPromotionCode =
            tile?.sashing?.flightPromoCode ??
            procuredOfferSash(tile.procuredOffer.procuredOfferId);
        }

        return (
          <ErrorBoundary key={index}>
            <StyledBox mb={7} id={tile.propertyContent.id}>
              <PropertyOption
                flightPromotionCode={tileFlightPromotionCode}
                tile={tile}
                priceForAdult={priceForAdult}
                hidePerPersonPrice={hidePerPersonPrice}
                index={index}
              />
            </StyledBox>
          </ErrorBoundary>
        );
      })}
    </>
  );
};

Tiles.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(Tile)).isRequired,
  priceForAdult: PropTypes.bool,
  hidePerPersonPrice: PropTypes.bool,
};

export default Tiles;
